export default "__VITE_ASSET__2bfa6e5b__"